module.exports = __webpack_public_path__ + "static/media/as-alonso-stanzani-advogados-associados-cartao-visita-768x591.0d02dbd9.jpg";